import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import deactivateIcon from "../../asserts/logo/DeactivateIcon.svg";

export default function DeactivateMetricDialog({ metric, onClose, onConfirm, submitting }) {
  const open = Boolean(metric);
  const name = (metric?.metricName || "").trim() || "this metric";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "4px",
          p: { xs: 2.5, sm: 3 },
          maxWidth: 480,
          position: "relative",
          boxShadow: "0 20px 40px rgba(16, 24, 40, 0.18)",
        },
      }}
    >
      <IconButton
        size="small"
        onClick={onClose}
        aria-label="Close"
        sx={{ position: "absolute", top: 12, right: 12, color: "#667085" }}
      >
        <CloseIcon sx={{ width: 24, height: 24 }} />
      </IconButton>

      <Box sx={{ textAlign: "center", pt: 1 }}>
        <Box
          sx={{
            position: "relative",
            width: 64,
            height: 64,
            mx: "auto",
            mb: 2,
          }}
        >
          <Box
            component="img"
            src={deactivateIcon}
            alt="Deactivate"
            sx={{
              position: "absolute",
              top: "12.8px",
              left: "10.67px",
              width: 42,
              height: 38,
              display: "block",
              opacity: 1,
              transform: "rotate(0deg)",
            }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 900,
            color: "#000000",
            lineHeight: "27px",
            mb: "16px",
            px: 1,
          }}
        >
          Deactivate {name}?
        </Typography>
        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 700,
            fontStyle: "normal",
            fontSize: "14px",
            lineHeight: "21px",
            letterSpacing: 0,
            textAlign: "center",
            verticalAlign: "middle",
            color: "#555555",
            mb: 3,
            px: 1,
          }}
        >
          Canonical metrics stay in the register as Deactivated. You can activate
          them again from this table at any time.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={submitting}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              color: "#1A6EF5",
              borderColor: "#1A6EF5",
              borderWidth: "1px",
              borderRadius: "4px",
              width: 77,
              minWidth: 77,
              height: 40,
              p: "8px 16px",
              gap: "4px",
              opacity: 1,
              boxSizing: "border-box",
              "&:hover": { borderColor: "#1251c0", bgcolor: "rgba(26, 110, 245, 0.04)" },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={submitting}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: "4px",
              minWidth: 77,
              height: 40,
              p: "8px 16px",
              gap: "4px",
              opacity: 1,
              boxSizing: "border-box",
              border: "1px solid #005BF0",
              boxShadow: "none",
              bgcolor: "#005BF0",
              "&:hover": { bgcolor: "#004BCC", borderColor: "#004BCC", boxShadow: "none" },
              "&.Mui-disabled": {
                bgcolor: "#F5F5F5",
                color: "#98A2B3",
                borderColor: "#E6E6E6",
                boxShadow: "0px 1px 2px 0px #0000000A",
                opacity: 1,
              },
            }}
          >
            {submitting ? "Deactivating…" : "Deactivate"}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
